import React from "react";
import {
  Box,
  Container,
  Grid,
  Typography,
  TextField,
  Button,
  Paper,
  useTheme,
  Chip,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  FormHelperText,
  Stack,
  useMediaQuery,
} from "@mui/material";
import VerifiedIcon from "@mui/icons-material/Verified";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import ShieldIcon from "@mui/icons-material/Shield";
import SendIcon from "@mui/icons-material/Send";
import LocalHospitalIcon from "@mui/icons-material/LocalHospital";

export const HeroSection = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [formData, setFormData] = React.useState({
    nome: "",
    telefone: "",
    email: "",
    tipoPlano: "",
  });

  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | { name?: string; value: unknown }>
  ) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name as string]: value,
    });
  };

  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    console.log("Dados do formulário:", formData);
    // Lógica para enviar os dados do formulário
  };

  return (
    <Box
      sx={{
        background: `linear-gradient(135deg, #cfffbc 0%, #65f82b 100%)`,
        py: { xs: 6, md: 12 },
        position: "relative",
        overflow: "hidden",
      }}
    >
      {/* Elementos decorativos */}
      <Box
        sx={{
          position: "absolute",
          top: "-10%",
          right: "-5%",
          width: "300px",
          height: "300px",
          borderRadius: "50%",
          background: `linear-gradient(135deg, #6be63b 0%, #164d01 100%)`,
          opacity: 0.1,
        }}
      />
      <Box
        sx={{
          position: "absolute",
          bottom: "-15%",
          left: "-10%",
          width: "400px",
          height: "400px",
          borderRadius: "50%",
          background: `linear-gradient(135deg, #6be63b 0%, #164d01 100%)`,
          opacity: 0.1,
        }}
      />

      <Container maxWidth="lg">
        <Grid container spacing={{ xs: 4, md: 8 }} alignItems="center">
          <Grid item xs={12} md={6}>
            <Box sx={{ position: "relative", zIndex: 1 }}>
              <Chip
                label="Planos de Saúde"
                icon={<LocalHospitalIcon color="inherit" />}
                sx={{
                  mb: 3,
                  fontWeight: 600,
                  color: "white",
                  backgroundColor: "#46e906",
                }}
              />
              <Typography
                variant="h2"
                component="h1"
                sx={{
                  fontWeight: 800,
                  mb: 3,
                  fontSize: { xs: "2.5rem", sm: "3rem", md: "4rem" },
                  lineHeight: 1.2,
                }}
              >
                Encontre o plano de saúde ideal para você e sua família
              </Typography>
              <Typography
                variant="h6"
                component="p"
                sx={{ mb: 4, fontWeight: "normal", opacity: 0.9 }}
              >
                Atendimento personalizado, as melhores operadoras e condições
                exclusivas para você
              </Typography>

              <Stack direction="column" spacing={2} sx={{ mb: 4 }}>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <VerifiedIcon
                    sx={{ mr: 1.5, color: theme.palette.info.main }}
                  />
                  <Typography>Cobertura completa para sua segurança</Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <VerifiedIcon
                    sx={{ mr: 1.5, color: theme.palette.info.main }}
                  />
                  <Typography>
                    Melhores hospitais e laboratórios da região
                  </Typography>
                </Box>
                <Box sx={{ display: "flex", alignItems: "center" }}>
                  <VerifiedIcon
                    sx={{ mr: 1.5, color: theme.palette.info.main }}
                  />
                  <Typography>Atendimento humanizado e rápido</Typography>
                </Box>
              </Stack>

              <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                <ShieldIcon sx={{ mr: 1.5, fontSize: 20 }} />
                <Typography variant="body2" sx={{ opacity: 0.8 }}>
                  ANS - Autorizado pela Agência Nacional de Saúde Suplementar
                </Typography>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={6} id="formulario">
            <Paper
              elevation={6}
              sx={{
                p: { xs: 3, md: 4 },
                borderRadius: "16px",
                background: "white",
                position: "relative",
                zIndex: 1,
                boxShadow:
                  "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
              }}
            >
              <Typography
                variant="h4"
                component="h2"
                sx={{ fontWeight: 700, mb: 1, color: "text.primary" }}
              >
                Solicite sua cotação
              </Typography>
              <Typography
                variant="body1"
                sx={{ mb: 3, color: "text.secondary" }}
              >
                Preencha o formulário abaixo e receba um atendimento
                personalizado
              </Typography>

              <Box component="form" noValidate onSubmit={handleSubmit}>
                <TextField
                  fullWidth
                  label="Nome completo"
                  variant="outlined"
                  margin="normal"
                  required
                  name="nome"
                  value={formData.nome}
                  onChange={handleChange}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Telefone / WhatsApp"
                  variant="outlined"
                  margin="normal"
                  required
                  name="telefone"
                  value={formData.telefone}
                  onChange={handleChange}
                  type="tel"
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="E-mail"
                  variant="outlined"
                  margin="normal"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  type="email"
                  sx={{ mb: 2 }}
                />

                <FormControl fullWidth margin="normal" sx={{ mb: 3 }}>
                  <InputLabel id="tipo-plano-label">Tipo de plano</InputLabel>
                  <Select
                    labelId="tipo-plano-label"
                    id="tipo-plano"
                    name="tipoPlano"
                    value={formData.tipoPlano}
                    label="Tipo de plano"
                    onChange={(e) =>
                      handleChange(e as React.ChangeEvent<HTMLInputElement>)
                    }
                  >
                    <MenuItem value="individual">Individual</MenuItem>
                    <MenuItem value="familiar">Familiar</MenuItem>
                    <MenuItem value="empresarial">Empresarial</MenuItem>
                    <MenuItem value="odontologico">Odontológico</MenuItem>
                  </Select>
                  <FormHelperText>
                    Selecione o tipo de plano de seu interesse
                  </FormHelperText>
                </FormControl>

                <Button
                  variant="contained"
                  fullWidth
                  size="large"
                  type="submit"
                  startIcon={<WhatsAppIcon />}
                  endIcon={<SendIcon />}
                  sx={{
                    backgroundColor: theme.palette.secondary.main,
                    py: 1.5,
                    borderRadius: "8px",
                    fontWeight: "bold",
                    "&:hover": {
                      backgroundColor: theme.palette.secondary.dark,
                    },
                  }}
                >
                  Solicitar cotação via WhatsApp
                </Button>
                <Typography
                  variant="caption"
                  display="block"
                  sx={{ mt: 1.5, textAlign: "center", color: "text.secondary" }}
                >
                  Seus dados estão protegidos e não serão compartilhados com
                  terceiros
                </Typography>
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
